import React from "react";

const FinancialYearDropdown = ({ selectedFinancialYear, onChange }) => {
  // Calculate the current year
  const currentYear = new Date().getFullYear();

  // Generate financial years from 2015-2016 to the current financial year
  const financialYears = Array.from({ length: currentYear - 2015 + 1 }, (_, i) => {
    const startYear = 2015 + i;
    const endYear = startYear + 1;
    return {
      value: `${startYear}-${endYear}`,
      label: `${startYear}-${endYear}`,
    };
  }).reverse(); // Reverse to show in descending order

  return (
    <div>
      <label
        htmlFor="financial-year"
        className="block text-gray-700 text-sm font-semibold mb-2"
      >
        Financial Year
      </label>
      <select
        id="financial-year"
        name="financialYear"
        value={selectedFinancialYear}
        onChange={onChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
      >
        <option value="">All</option>
        {financialYears.map((year) => (
          <option key={year.value} value={year.value}>
            {year.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FinancialYearDropdown;
